import { GeometryData } from "./apidatamodel"
/** yhteiskäyttön model kunnille ja maakunnille */
export default class MunicipalitiesAndRegionsModel {
    constructor(
        nimi: string,
        maakuntanumero: string,
        namn?: string,
        kuntanumero?: string,
        geoms?: any,
        koordinaatit?: GeometryData | null) {
            this.nimi = nimi
            this.namn = namn
            this.kuntanumero = kuntanumero
            this.maakuntanumero = maakuntanumero
            this.koordinaatit = koordinaatit
            this.geoms = geoms
        }

    nimi: string
    namn?: string
    kuntanumero?: string
    maakuntanumero: string
    geoms?: any
    koordinaatit?: GeometryData | null

    static empty(): MunicipalitiesAndRegionsModel[] {
        const empty: MunicipalitiesAndRegionsModel[] = []
        return empty
    }
}
